import { useCallback } from "react";

import { type AwsMarketplaceAccountModel, CustomerModel, MarketplaceModel } from "@doitintl/cmp-models";
import { getCollection, type ModelReference, type WithModel } from "@doitintl/models-any";
import { type TransformMethod, useCollectionData } from "@doitintl/models-hooks";

export const useAwsCustomersData = () =>
  useCollectionData(getCollection(CustomerModel).where("marketplace.AWS.accountExists", "==", true), { idField: "id" });

type AccountData = {
  account: WithModel<AwsMarketplaceAccountModel>;
  accountRef: ModelReference<AwsMarketplaceAccountModel>;
};

export const useAccountData = () => {
  const transform: TransformMethod<AwsMarketplaceAccountModel, AccountData> = useCallback(
    (data, docSnapshot): AccountData => ({ account: data, accountRef: docSnapshot.modelRef }),
    []
  );

  return useCollectionData(
    getCollection(MarketplaceModel).doc("aws-marketplace").collection("awsMarketplaceAccounts"),
    {
      transform,
    }
  );
};
